import XLSX from "xlsx-js-style";
import { isEmpty } from "../../../utils/helpers";
import { styleSimpleSOETableContent } from "../modal/excel.exports.styles";

export const processSoeContent = ({
  soeContent,
  scheduleOfEventsAssessments,
  visitsAndAssessmentsMapping,
  simpleSoeReport,
}) => {
  scheduleOfEventsAssessments["study"]
    .filter((sa) =>
      ["Procedure", "Non Procedure"].includes(sa.assessmentType),
    )
    .forEach((assessment) => {
      soeContent.push([
        `${assessment.assessmentType} - ${assessment.assessmentName}`,
        ...visitsAndAssessmentsMapping[
          assessment.scheduleOfEventsAssessmentId || assessment.key
        ]?.map((v) => {
          if (simpleSoeReport) {
            let result = "";
            if (!isEmpty(v?.uniqueNonUniqueForm)) {
              const uniqueNonUniqueForm = ((v?.uniqueNonUniqueForm === "N") ? "NU" : v?.uniqueNonUniqueForm) || "";
              result = `${uniqueNonUniqueForm}[${v?.multiplier || ""}]`;
            } else if (Number(v?.multiplier) > 0) {
              result = `[${v?.multiplier}]`;
            }
            return result;
          }
          return v?.multiplier || "";
        }),
      ]);
    });
};

const filename_base = (currentSOE) =>
  `${(currentSOE.scheduleOfEventsName || "").replaceAll(
    " ",
    "_",
  )}_${new Date().toString()}_${currentSOE.studyId}_Export`;

export const download_simple_soe = ({
  scheduleOfEventsVisits,
  scheduleOfEventsAssessments,
  visitsAndAssessmentsMapping,
  currentSOE,
}) => {
  try {
    const wb = XLSX.utils.book_new();

    const sheetName = "SOE";
    const header = scheduleOfEventsVisits["study"].map((visit) => visit.visitName);
    const content = [["Assessment Name", ...header]];
    processSoeContent({
      soeContent: content,
      scheduleOfEventsAssessments,
      visitsAndAssessmentsMapping,
      simpleSoeReport: true,
    });
    const styledContent = styleSimpleSOETableContent(content);
    let sheetCols = [];
    if (content.length > 0) {
      sheetCols = content[0].map((_, index) =>
        index === 0 ? { width: 40 } : { width: 20 }
      );
    }
    const sheet = XLSX.utils.aoa_to_sheet(styledContent);
    if (sheetCols) {
      sheet["!cols"] = sheetCols;
    }
    XLSX.utils.book_append_sheet(wb, sheet, sheetName);
    XLSX.writeFile(wb, `${filename_base(currentSOE)}.xlsx`, XLSX.cellDates);
  } catch (err) {
    console.log(err);
  }
};